GatiServerGame = function () {
  var base = new GatiServer();
  GatiServer.call(this, base);
  this.inFS = false;
  this.fsIndex = 0;
  this.fsWinnings = 0;
  this.fsCount = 0;

  this.fireballCostMultiplier = 50;
  this.freeSpinsCostMultiplier = 120;

  this.fireballActive = false;

  this.addGameConfigToQueueBase = this.addGameConfigToQueue;
  this.addGameConfigToQueue = this.addGameConfigToQueueDerived;
  this.addRecoveryToQueueBase = this.addRecoveryToQueue;
  this.addRecoveryToQueue = this.addRecoveryToQueueDerived;
  this.startGameBase = this.startGame;
  this.startGame = this.startGameDerived;

  this.isGameModeBonusBuyBase = this.isGameModeBonusBuy;
  this.isGameModeBonusBuy = this.isGameModeBonusBuyDerived;

  this.restorePreviousWagersBase = this.restorePreviousWagers;
  this.restorePreviousWagers = this.restorePreviousWagersDerived;

  this._inBuyABonus = false;
  this._inEncore = false;

  //this.loadLanguageFiles = undefined; // delete me when translations are ready
};

GatiServerGame.prototype = Object.create(GatiServer.prototype);

GatiServerGame.prototype.initServer = function (cb) {
  this.init(
    function () {
      cb();
    },
    function () {},
    undefined,
    "LEFT_TOP"
  );
};

GatiServer.prototype.isGameModeBonusBuyDerived = function (mode) {
  return mode === "FIREBALL_BUY" || mode === "FREESPINS_BUY";
};

GatiServerGame.prototype.addGameConfigToQueueDerived = function (loadData) {
  this.addGameConfigToQueueBase(loadData);

  let message = this._messageQueue[0];
  message.buyBonusCostFireball = this.fireballCostMultiplier;
  message.buyBonusCostFreeSpins = this.freeSpinsCostMultiplier;

  gameData.recoveryStake = undefined;

  if (loadData.wagers.data.length) {
    let betData = loadData.wagers.data[0].bets[0].betdata;
    let stake = Number(betData.coin * 1000);

    gameData.recoveryStake = stake;

    if (betData.cmd === "LUCKYBET_BUY") {
      gameData.recoveryStake *= 1.25;
    }
  }

  gdk.addConfigValue(
    "AllowBuyBonus",
    message.slotConfig.gameModes["BONUS_BUY"] ? true : false
  );

  message.maxExposure = loadData.settings.slotConfig.MaxExposure;

  this.processSuperWilds(
    loadData.settings.slotConfig.Config["spinner:GameConfigEvent"].slotConfig
      .startingSymbols
  );
};

GatiServerGame.prototype.addRecoveryToQueueDerived = function () {
  for (let i = 0; i < this._latestEngineReponse.wager.bets.length; ++i) {
    let bet = this._latestEngineReponse.wager.bets[i];
    if (bet.betdata.cmd === "LUCKYBET_BUY") {
      this._inEncore = true;
      this._meta = {
        name: "encore",
        value: true,
      };
      break;
    } else if (bet.betdata.cmd === "FIREBALL_BUY") {
      this._inBuyABonus = true;
      this.fireballActive = true;
      this._meta = {
        name: "buyABonusFireBall",
        value: true,
        fireballActive: true,
      };
      break;
    } else if (bet.betdata.cmd === "FREESPINS_BUY") {
      this._inBuyABonus = true;
      this.fireballActive = false;
      this._meta = {
        name: "buyABonusFreeSpins",
        value: true,
        fireballActive: false,
      };
      break;
    }
  }
  this.addRecoveryToQueueBase();
};

GatiServerGame.prototype.startGameDerived = function (stakeData, cb) {
  this._inBuyABonus = stakeData.metaData.buyABonus;
  this._inEncore = stakeData.metaData.encore;

  this.fireballActive =
    stakeData.metaData.fireballActive !== undefined
      ? stakeData.metaData.fireballActive
      : false;

  this.startGameBase(stakeData, cb);
};

GatiServerGame.prototype.restorePreviousWagersDerived = function () {
  let res = this.restorePreviousWagersBase();

  if (
    this._previousWagers &&
    this._previousWagers.data &&
    this._previousWagers.data.length > 0 &&
    this._previousWagers.data[0].bets &&
    this._previousWagers.data[0].bets.length > 0 &&
    this._previousWagers.data[0].bets[0].betdata.cmd === "LUCKYBET_BUY"
  ) {
    res.baseStake *= 10; // coin for lucky bet is 10x bigger
    this.setDefaultBet(res.baseStake);
  }
  return res;
};

GatiServerGame.prototype.addMetaDataToSpinRequest = function (request) {
  this._coinValue = 10;
  let stakeController = resourceManager.getController("stakeController");
  let baseStake = stakeController.getBaseStake("default") / 100;

  request.coin = request.amount / this._coinValue;
  request.coins = this._coinValue;

  if (this._inEncore) {
    this._coinValue = 100; // has to be whole number
    request.amount = baseStake * 1.25;
    request.coin = baseStake / this._coinValue;
    request.cmd = "LUCKYBET_BUY";
  } else if (this._inBuyABonus) {
    baseStake =
      stakeController.getBaseStake(
        this.fireballActive ? "FIREBALL_BUY" : "FREESPINS_BUY"
      ) / 100;

    request.amount =
      baseStake *
      (this.fireballActive
        ? this.fireballCostMultiplier
        : this.freeSpinsCostMultiplier);
    request.coin = baseStake / this._coinValue;
    request.cmd = this.fireballActive ? "FIREBALL_BUY" : "FREESPINS_BUY";
  }
};

GatiServerGame.prototype.addFSStartToQueue = function (
  numFS,
  volcanoBoosts,
  bonusSymbolPositions
) {
  this.fsCount = 0;
  let message = {};
  message.type = "spinner:FreeSpinsStartEvent";
  message.freeSpinsAwarded = numFS;
  message.volcanoBoosts = volcanoBoosts;
  message.bonusSymbolPositions = bonusSymbolPositions;
  this.fsWinnings = 0;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSDataToQueue = function () {
  let message = {};
  message.type = "spinner:FreeSpinsDataEvent";
  message.num = this.fsCount + 1;
  message.fsWinnings = this.fsWinnings;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addinitialRetriggerToQueue = function () {
  let message = {};
  message.type = "8bof:initialRetrigger";
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSRetriggerToQueue = function (freespinsToAdd) {
  let message = {};
  message.type = "spinner:FreeSpinsRetriggerEvent";
  message.num = freespinsToAdd;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFSEndToQueue = function (winnings, isCapped) {
  let message = {};
  message.type = "spinner:FreeSpinsEndEvent";
  message.fsWinnings = winnings;
  message.isBigWin = false;
  message.isCapped = isCapped;
  this.fsWinnings = 0;
  this.inFS = false;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinData = function (cb, data) {
  if (this.inFireballLink) {
    this.getSpinDataFBL(cb);
  } else if (this.inFS) {
    this.getSpinDataFS(cb);
  } else {
    let parts = data.Parts;

    let hasFreespins = false;
    for (let i = 0; i < parts.length; ++i) {
      if (parts[i].type === "freeSpins") {
        hasFreespins = true;
      }
    }

    let totalWon = 0;
    for (let i = 0; i < parts.length; ++i) {
      let type = parts[i].type;
      if (type === "baseGame") {
        totalWon += this.getSpinDataNormal(parts[i]);
        // base game only, game complete
        if (!parts[i].fireballLink && !hasFreespins) {
          this.addGameCompleteToQueue(totalWon);
        }
      } else if (type === "freeSpins") {
        this.inFS = true;
        this.fsCount = 0;
        this.freeSpins = parts[i].spins;

        const bonusSymbols = [];
        const symbols = resourceManager.getConfiguration().symbols;
        for (
          let reel = 0;
          reel < parts[0].baseSpin.spin.spinEvent.resultsPanel.reelList.length;
          ++reel
        ) {
          for (
            let row = 0;
            row <
            parts[0].baseSpin.spin.spinEvent.resultsPanel.reelList[reel].symbols
              .length;
            ++row
          ) {
            const symbol =
              parts[0].baseSpin.spin.spinEvent.resultsPanel.reelList[reel]
                .symbols[row].value;
            if (symbol === symbols["Symbol_Bonus"].ID) {
              bonusSymbols.push({ reel, row });
            }
          }
        }

        this.addFSStartToQueue(
          parts[i].initialNumberOfSpins,
          parts[i].initialVolcanoBoosts,
          bonusSymbols
        );
      }
    }
    cb();
    this.triggerNextMessage();
  }
};

GatiServerGame.prototype.updateCurrentStake = function (newStake) {
  if (this._stake != newStake) {
    let isStakeLower = newStake < this._stake;
    this._stake = newStake;
    this._slotGame.getGameEventsEmitter().totalBetChanged(this._stake / 100);

    let sc = resourceManager.getController("stakeController");
    if (
      sc.isMaxStake() &&
      !this._inReplayMode &&
      !this._inRewatchMode &&
      !this._isPrePaidGame &&
      !isStakeLower
    ) {
      this._slotGame.uiComponents().clickActionHandler();
    }
  }
};

GatiServerGame.prototype.setBPL = function (bpl) {
  // this doesn't set the correct stake in recovery - but shouldn't affect anything...
  let baseStake = this._numLines * bpl;
  let newStake = baseStake;
  if (gameData.encoreEnabled) {
    newStake *= 1.25;
  } //else if ( this._inBuyABonus ) {
  //	newStake *= this.fireballActive ? this.fireballCostMultiplier : this.freeSpinsCostMultiplier;
  //}

  this.updateCurrentStake(newStake);
};

GatiServerGame.prototype.getFireballIdFromCash = function (fireball) {
  const symbols = resourceManager.getConfiguration().symbols;
  const firstCashFireballId = symbols["Symbol_Fireball20"].ID;
  const possibleValues = [20, 40, 60, 80, 100, 200, 300, 400, 500];

  // base stake is good for both base game and golden bet
  let stakeController = resourceManager.getController("stakeController");
  let stake = stakeController.getBaseStake("default");

  if (this._inBuyABonus) {
    stake = stakeController.getBaseStake(
      this.fireballActive ? "FIREBALL_BUY" : "FREESPINS_BUY"
    );
  }

  const stakeIndependentValue = fireball.amount / (stake / gameData.numLines);
  const index = possibleValues.indexOf(stakeIndependentValue);
  if (index >= 0) {
    return firstCashFireballId + index;
  }
  return -1;
};

GatiServerGame.prototype.getFireballIdFromPot = function (fireball) {
  const symbols = resourceManager.getConfiguration().symbols;
  const firstPotFireballId = symbols["Symbol_FireballMini"].ID;
  const possibleValues = ["Mini", "Minor", "Major", "Mega"];
  const index = possibleValues.indexOf(fireball.potName);
  if (index >= 0) {
    return firstPotFireballId + index;
  }
  return -1;
};

GatiServerGame.prototype.getFireballId = function (fireball) {
  switch (fireball.type) {
    case "Cash":
    case "WildCash": {
      return this.getFireballIdFromCash(fireball);
    }
    case "Pot":
    case "WildPot": {
      return this.getFireballIdFromPot(fireball);
    }
    case "Multiplier":
    case "WildMultiplier": {
      const symbols = resourceManager.getConfiguration().symbols;
      return symbols["Symbol_FireballX2"].ID;
    }
    default: {
      console.log("fireball id error");
    }
  }
  return -1;
};

GatiServerGame.prototype.convertFireballIds = function (spinEvent, fireballs) {
  const self = this;
  fireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const id = self.getFireballId(fireball);
    spinEvent.resultsPanel.reelList[reel].symbols[row].value = id;
  });
};

GatiServerGame.prototype.getPrizeDataFromFireball = function (fireball) {
  let prizeData = { type: fireball.type };
  switch (fireball.type) {
    case "Cash":
    case "WildCash": {
      prizeData.value = fireball.amount;
      break;
    }
    case "Pot":
    case "WildPot": {
      prizeData.potName = fireball.potName;
      prizeData.value = fireball.potValue;
      break;
    }
    case "Multiplier":
    case "WildMultiplier": {
      prizeData.value = fireball.multiplier;
      break;
    }
    default: {
      console.log("fireball id error");
    }
  }
  return prizeData;
};

GatiServerGame.prototype.addFireballLinkStartToQueue = function (
  startingFireballs
) {
  var message = {};
  message.type = "8bof:FireballLinkStartEvent";

  const self = this;
  message.startingFireballs = [];
  startingFireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const symbolId = self.getFireballId(fireball);
    const prizeData = self.getPrizeDataFromFireball(fireball);
    message.startingFireballs.push({ reel, row, symbolId, prizeData });
  });
  message.livesRemaining = 3;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballLinkDataToQueue = function (
  blanks,
  newFireballs,
  livesRemaining
) {
  var message = {};
  message.type = "8bof:FireballLinkDataEvent";

  const self = this;
  message.blanks = blanks;
  message.newFireballs = [];
  newFireballs.forEach(function (fireball) {
    const reel = fireball.coord.reel;
    const row = fireball.coord.row;
    const symbolId = self.getFireballId(fireball);
    const prizeData = self.getPrizeDataFromFireball(fireball);

    message.newFireballs.push({ reel, row, symbolId, prizeData });
  });
  message.livesRemaining = livesRemaining;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballLinkEndToQueue = function (win) {
  var message = {};
  message.type = "8bof:FireballLinkEndEvent";
  message.winAmount = win;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballsLandedToQueue = function (fireballs) {
  var message = {};
  message.type = "8bof:FireballsLandedEvent";
  message.fireballs = fireballs;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addPotBonusStartToQueue = function (
  potWon,
  sequence,
  winAmount
) {
  var message = {};
  message.type = "8bof:PotBonusStartEvent";
  message.potWon = potWon;
  message.sequence = sequence;
  message.winAmount = winAmount;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.checkForSuperWildOnReel = function (
  symbols,
  start,
  count
) {
  const sWild = 9;
  let allSWilds = true;
  for (let row = start; row < start + count; ++row) {
    if (symbols[row].value != sWild) {
      allSWilds = false;
    }
  }
  return allSWilds;
};

GatiServerGame.prototype.replaceSuperWildOnReel = function (
  symbols,
  start,
  count,
  symbolId
) {
  for (let row = start; row < start + count; ++row) {
    symbols[row].value = symbolId;
  }
};

GatiServerGame.prototype.processSuperWilds = function (reelList) {
  const sWild_x2 = 42;
  const sWild_x3 = 43;
  for (let reel = 0; reel < reelList.length; ++reel) {
    if (this.checkForSuperWildOnReel(reelList[reel].symbols, 0, 3)) {
      this.replaceSuperWildOnReel(reelList[reel].symbols, 0, 3, sWild_x3);
    } else if (this.checkForSuperWildOnReel(reelList[reel].symbols, 0, 2)) {
      this.replaceSuperWildOnReel(reelList[reel].symbols, 0, 2, sWild_x2);
    } else if (this.checkForSuperWildOnReel(reelList[reel].symbols, 1, 2)) {
      this.replaceSuperWildOnReel(reelList[reel].symbols, 1, 2, sWild_x2);
    }
  }
};

GatiServerGame.prototype.processSuperWildWins = function (
  winningLinesEvent,
  reelList
) {
  for (let line = 0; line < winningLinesEvent.winningLines.length; ++line) {
    for (
      let id = 0;
      id < winningLinesEvent.winningLines[line].symbol.ids.length;
      ++id
    ) {
      if (winningLinesEvent.winningLines[line].symbol.ids[id] === 9) {
        const reel = winningLinesEvent.winningLines[line].positions[id].reel;
        const row = winningLinesEvent.winningLines[line].positions[id].row;

        winningLinesEvent.winningLines[line].symbol.ids[id] =
          reelList[reel].symbols[row].value;
      }
    }
  }
};

GatiServerGame.prototype.addEndOfBaseGameSpinToQueue = function (
  totalWin,
  isCapped
) {
  var message = {};
  message.type = "8bof:EndOfBaseGameSpinEvent";
  message.totalWin = totalWin;
  message.isCapped = isCapped;
  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataNormal = function (data) {
  const spin = data.baseSpin.spin;
  const spinEvent = spin.spinEvent;

  const winningLinesEvent = spin.winningLinesEvent;

  if (!this.validateResponse(spinEvent)) return;
  if (!this.validateResponse(winningLinesEvent)) return;

  this.convertFireballIds(spinEvent, data.baseSpin.fireballs);
  this.addSpinDataToQueue(spinEvent);

  const message = this._messageQueue[this._messageQueue.length - 1];
  message.fireballLink = data.fireballLink;

  this.processSuperWilds(spin.spinEvent.resultsPanel.reelList);

  const spinMessage = this._messageQueue[this._messageQueue.length - 1];
  spinMessage.isFbl = data.fireballLink;
  spinMessage.isPotBonus = data.potPick;
  spinMessage.isPrePaidGame = this._isPrePaidGame;

  if (data.isWildFire) {
    spinMessage.wildFireFireballs = [];
    data.baseSpin.fireballs.forEach(function (fireball) {
      spinMessage.wildFireFireballs.push({
        reel: fireball.coord.reel,
        row: fireball.coord.row,
        amount: fireball.amount,
      });
    });
    spinMessage.isWildFire = true;
  }

  if (
    !data.fireballLink &&
    data.baseSpin.fireballs &&
    data.baseSpin.fireballs.length > 0
  ) {
    let fireballs = [...data.baseSpin.fireballs];

    this.addFireballsLandedToQueue(fireballs);
  }

  if (winningLinesEvent.totalLineWinnings > 0) {
    this.processSuperWildWins(
      winningLinesEvent,
      spin.spinEvent.resultsPanel.reelList
    );
    this.addWinningsToQueue(winningLinesEvent);
    const message = this._messageQueue[this._messageQueue.length - 1];
    message.winIsCapped = spin.winCapped;
  }

  if (data.fireballLink) {
    this.inFireballLink = true;
    this.fireballLinkCount = 0;
    this.fireballLinkSpins = data.fireballLink.spins;
    this.fireballLinkTotalWin = data.fireballLink.winAmount;
    this.addFireballLinkStartToQueue(data.baseSpin.fireballs);
  }

  this.baseGameSpinData = data;
  if (!data.fireballLink) {
    this.finishSpin(data);
  }

  return spinEvent.totalWinnings;
};

GatiServerGame.prototype.finishSpin = function (data) {
  if (
    data.fireballLink &&
    data.baseSpin.fireballs &&
    data.baseSpin.fireballs.length > 0
  ) {
    let fireballs = [...data.baseSpin.fireballs];
    fireballs.forEach(function (fireball) {
      fireball.fblFireball = false;
    });

    let newFireballs = [];
    data.fireballLink.spins.forEach(function (spin) {
      spin.newFireballs.forEach(function (fireball) {
        fireball.fblFireball = true;
        newFireballs.push(fireball);
      });
    });
    fireballs.push(...newFireballs);

    this.addFireballsLandedToQueue(fireballs);
  }
  if (data.potPick) {
    this.addPotBonusStartToQueue(
      data.potPick.potWon,
      data.potPick.sequence,
      data.potPick.winAmount
    );
  }
  this.addEndOfBaseGameSpinToQueue(data.winAmount, data.winCapped);
};

GatiServerGame.prototype.getSpinDataFBL = function (cb) {
  const thisOutcome = this.fireballLinkSpins[this.fireballLinkCount];

  if (this.fireballLinkCount < this.fireballLinkSpins.length) {
    ++this.fireballLinkCount;
    this.addFireballLinkDataToQueue(
      thisOutcome.blanks,
      thisOutcome.newFireballs,
      thisOutcome.livesRemaining
    );
  } else {
    this.addFireballLinkEndToQueue(this.fireballLinkTotalWin);
    this.inFireballLink = false;

    if (this.inFS) {
      let thisFsOutcome = this.freeSpins[this.fsCount - 1];
      this.finishFSSpin(thisFsOutcome);
    } else {
      this.finishSpin(this.baseGameSpinData);
    }

    if (!this.inFS || this.fsCount >= this.freeSpins.length) {
      this.inFS = false;
      this.addGameCompleteToQueue(0);
    }
  }
  cb();
  this.triggerNextMessage();
};

GatiServerGame.prototype.finishFSSpin = function (thisFsOutcome) {
  this.addFireballAwardsToQueue(thisFsOutcome.fireballAwards);

  this.addDemotionsToQueue(thisFsOutcome.demotions);

  this.fsWinnings += thisFsOutcome.winAmount;

  if (this.fsCount < this.freeSpins.length) {
    this.addFSDataToQueue();
  } else {
    if (!this.inFBL) {
      this.addFSEndToQueue(this.fsWinnings, thisFsOutcome.winCapped);
      this.addGameCompleteToQueue(this.fsWinnings);
      this.inFS = false;
    }
  }
};

GatiServerGame.prototype.addDemotionsToQueue = function (demotions) {
  var message = {};
  message.type = "8bof:Demotions";
  message.demotions = demotions;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.addFireballAwardsToQueue = function (awards) {
  var message = {};
  message.type = "8bof:FireballAwards";
  message.fireballAwards = awards;

  this._messageQueue.push(message);
};

GatiServerGame.prototype.getSpinDataFS = function (cb) {
  let thisFsOutcome = this.freeSpins[this.fsCount++];

  let spin = thisFsOutcome.baseSpin.spin;
  let spinEvent = spin.spinEvent;

  let winningLinesEvent = spin.winningLinesEvent;

  this.convertFireballIds(spinEvent, thisFsOutcome.baseSpin.fireballs);
  this.addSpinDataToQueue(spinEvent);
  this.processSuperWilds(spin.spinEvent.resultsPanel.reelList);

  const message = this._messageQueue[this._messageQueue.length - 1];
  message.newActivations = thisFsOutcome.activations;

  // we need to do this first thing after the spin event to look for the retrigger
  // as the bell needs to sound as soon as the reels are all landed
  let fbAwards = thisFsOutcome.fireballAwards;
  if (fbAwards !== null) {
    for (let j = 0; j < fbAwards.events.length; j++) {
      if (fbAwards.events[j].type === "Retrigger") {
        this.addinitialRetriggerToQueue();
      }
    }
  }

  if (
    winningLinesEvent.totalLineWinnings > 0 &&
    winningLinesEvent.winningLines.length > 0
  ) {
    this.processSuperWildWins(
      winningLinesEvent,
      spin.spinEvent.resultsPanel.reelList
    );
    this.addWinningsToQueue(winningLinesEvent);
  }

  if (thisFsOutcome.fireballLink) {
    this.inFireballLink = true;
    this.fireballLinkCount = 0;
    this.fireballLinkSpins = thisFsOutcome.fireballLink.spins;
    this.fireballLinkTotalWin = thisFsOutcome.fireballLink.winAmount;
    this.addFireballLinkStartToQueue(thisFsOutcome.baseSpin.fireballs);
  } else {
    this.finishFSSpin(thisFsOutcome);
  }

  cb();
  this.triggerNextMessage();
};
